import React from 'react';
import FormLabel from './FormLabel';

/**
 * Editable list of requirement strings. Add/remove items.
 */
export default function RequirementsList({ value = [], onChange, disabled, className = '' }) {
  const items = Array.isArray(value) ? value : [];

  const addItem = () => {
    onChange?.([...items, '']);
  };

  const removeItem = (index) => {
    onChange?.(items.filter((_, i) => i !== index));
  };

  const updateItem = (index, text) => {
    const next = [...items];
    next[index] = text;
    onChange?.(next);
  };

  return (
    <div className={`form-group requirements-list ${className}`}>
      <FormLabel>Requirements</FormLabel>
      <ul className="requirements-list__list list-unstyled mb-0">
        {items.map((item, index) => (
          <li key={index} className="requirements-list__item d-flex align-items-center gap-2 mb-2">
            <input
              type="text"
              className="form-control form-control-sm"
              value={item}
              onChange={(e) => updateItem(index, e.target.value)}
              placeholder={`Requirement ${index + 1}`}
              disabled={disabled}
            />
            <button
              type="button"
              className="btn btn-outline-danger btn-sm requirements-list__btn-remove"
              onClick={() => removeItem(index)}
              disabled={disabled}
              title="Remove"
              aria-label="Remove requirement"
            >
              <i className="bi bi-dash-lg" />
            </button>
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm mt-1"
        onClick={addItem}
        disabled={disabled}
      >
        <i className="bi bi-plus me-1" />
        Add requirement
      </button>
    </div>
  );
}
